import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getAdminPref } from "@/components/AdminChoiceModal";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-[#9ca3af] font-mono text-sm">
      Loading…
    </div>
  );
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
};

export const PublicOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) {
    // If admin is on the choice screen (login page just showed the modal),
    // the Login page manages navigation itself — don't intercept.
    if (sessionStorage.getItem("veerox_admin_choice_pending") === "1") return children;
    // Otherwise: role-aware default landing. Admin → their remembered pref
    // (defaults to /admin); user → /dashboard.
    if (user.role === "admin") {
      const pref = getAdminPref();
      return <Navigate to={pref === "user" ? "/dashboard" : "/admin"} replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};
